import { render, staticRenderFns } from "./ClipboardDrawer.vue?vue&type=template&id=38590c84&scoped=true"
import script from "./ClipboardDrawer.vue?vue&type=script&lang=js"
export * from "./ClipboardDrawer.vue?vue&type=script&lang=js"
import style0 from "./ClipboardDrawer.vue?vue&type=style&index=0&id=38590c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38590c84",
  null
  
)

export default component.exports